import styles from './steps.module.scss';
import { EpStepContent } from '../../../../../components/HookFormComponents/components/EpStepContent';
import AnonymousSwitch from '../../../../../components/HookFormComponents/Inputs/AnonymousSwitch';
import NotifierEmailInput from '../../../../../components/HookFormComponents/Inputs/NotifierEmailInput';
import NotifierNameInput from '../../../../../components/HookFormComponents/Inputs/NotifierNameInput';
import NotifierOccupationInput from '../../../../../components/HookFormComponents/Inputs/NotifierOccupationInput';
import NotifierUnitInput from '../../../../../components/HookFormComponents/Inputs/NotifierUnitInput';
import SafetyHuddleSwitch from '../../../../../components/HookFormComponents/Inputs/SafetyHuddleSwitch';
import { useTranslation as t } from '../../../../../hooks/useTranslation';
import { globalizationService } from '../../../../../services/globalizationService';
import { EpModal, hideModal } from '../../../../EpModal';
import { useFormContext } from 'react-hook-form';

export default function Step4IncidentNotification() {
  const tag = 'PSNotificationDM';
  const { translations } = globalizationService.getTranslationsByTag(tag);
  const { setValue } = useFormContext();

  return (
    <div className={styles['steps']}>
      <EpStepContent.Card title={t(translations, 'Detection Mechanism')}>
        <AnonymousSwitch translations={translations} />
        <NotifierOccupationInput translations={translations} />
        <NotifierNameInput translations={translations} />
        <NotifierEmailInput translations={translations} />
      </EpStepContent.Card>
      <EpStepContent.Card title={t(translations, 'Origin of notification')}>
        <NotifierUnitInput translations={translations} />
        <SafetyHuddleSwitch translations={translations} />
      </EpStepContent.Card>
    </div>
  );
}
